import { gql, useQuery } from '@apollo/client';
import { DomainResources } from '../../../models/types';

export interface DomainResourceVars {
  domainIdentifier: string;
}

export interface DomainResourcesData {
  domain: {
    domainIdentifier: string;
    esVersion: string;
    cellId: string;
    HAProxyVersion: string;
    HAProxyType: string;
    resources: {
      ALL: DomainResources;
    };
    DomainCreateDateTime: string;
  };
}

export const RESOURCE_INFO = gql`
  query getDomainDetails($domainIdentifier: String!, $piezoArtifacts: JSON) {
    domain(domainIdentifier: $domainIdentifier, piezoArtifacts: $piezoArtifacts) {
      domainIdentifier
      esVersion
      cellId
      HAProxyVersion
      HAProxyType
      pinnedVFIDomain
      pinnedVFIClient
      IsSensitiveDomain
      IsSensitiveClient
      IsDomainIsolated
      carbonDomain
      DomainCreateDateTime
      PackageTypeAssociatedOnDomain
      IsIndexLevelEncryptionEnabled
      DeploymentStrategy
      UpgradeDeploymentStrategy
      IsZoaEnabled
      dragonstoneDomain
      isMustangDomain
      IsRemotePublicationEnabled
      resources {
        ALL
      }
    }
  }
`;

export const useResourceInfoQuery = (vars: DomainResourceVars) => {
  return useQuery<DomainResourcesData, Record<string, unknown>>(RESOURCE_INFO, {
    variables: { ...vars },
    errorPolicy: 'all',
  });
};
